import { GenericService } from 'services/genericService';
import { Observable } from 'rxjs';
import {
	getCustomerAccountBills,
	getCustomerBills,
	getCorpBillingIds,
	getBillsHistoryForAccounts,
	getEBillInformation,
	updateEbillEmails,
	getCustomerUnpaidBillsForAccounts,
} from 'utils/api/queries/omantelApi';
import { BillingRequest, Bills } from 'utils/api/models/bills/bills';
import { BillPdf } from 'utils/api/models/bills/billPdf';
import { BillingIds } from 'utils/api/models/bills/billingIds';
import { BillsHistoryForAccount } from 'utils/api/models/bills/billsHistoryForAccount';
import * as payloads from 'utils/api/payloads/omantelApi';
import { UnpaidBills } from 'utils/api/models/bills/unpaidBills';
import {
	createBillingRequest,
	downloadBillingRequest,
	getBillingRequest,
	getEbillInfo,
} from 'utils/api/queries/microApi';
import { AjaxResponse } from 'rxjs/ajax';

export class BillsService extends GenericService {
	public static getCustomerUnpaidBills(): Observable<Bills> {
		return getCustomerAccountBills()
			.withErrorHandling()
			.call();
	}

	public static getCustomerBills(customerBill: payloads.CustomerBillInfo): Observable<BillPdf> {
		return getCustomerBills(customerBill)
			.withErrorHandling()
			.call();
	}

	public static getCorpBillingIds(): Observable<BillingIds> {
		return getCorpBillingIds()
			.withErrorHandling()
			.call();
	}

	public static getBillsHistoryForAccounts(data: payloads.BillsHistoryData): Observable<BillsHistoryForAccount> {
		return getBillsHistoryForAccounts(data)
			.disableCache()
			.withErrorHandling()
			.call();
	}

	public static getEBillInformation(data: payloads.EBillData): Observable<any> {
		return getEBillInformation(data)
			.withErrorHandling()
			.call();
	}

	public static updateEbillEmails(data: payloads.UpdateEbillsEmailsData): Observable<any> {
		return updateEbillEmails(data)
			.withErrorHandling()
			.disableCache()
			.call();
	}

	public static getCustomerUnpaidBillsForAccounts(billingId?: string): Observable<UnpaidBills> {
		return getCustomerUnpaidBillsForAccounts(billingId).call();
	}

	public static getBillingRequest(): Observable<BillingRequest> {
		return getBillingRequest()
			.withErrorHandling()
			.call();
	}

	public static createBillingRequest(data: payloads.CreateBillingRequest): Observable<BillingRequest> {
		return createBillingRequest(data)
			.withErrorHandling()
			.call();
	}

	public static downloadBillingRequest(data: payloads.CreateBillingRequest): Observable<AjaxResponse> {
		return downloadBillingRequest(data).call();
	}

	public static getEbillInfo(billingAccountNumber: string, attributes: string[]): Observable<AjaxResponse> {
		return getEbillInfo(billingAccountNumber, attributes).call();
	}
}
